<template>
  <b-card no-body>
    <h4 class="pl-1 pt-1">Listado de MP</h4>
    <b-table-simple striped hover small>
      <b-thead>
        <b-th v-for="(field, fieldIdx) in fields" :key="fieldIdx">
          {{ field.label }}
          <i class="fa fa-sort"></i>
        </b-th>
      </b-thead>
      <draggable
        :class="{ [`cursor-grabbing`]: drag === true, ['cursor-grab']: drag === false }"
        v-model="localItems"
        group="items"
        @start="drag = true"
        @end="handleEnd"
        tag="tbody"
      >
        <b-tr v-for="item in items" :key="item.id" class="item-row">
          <b-td v-for="(value, name) in fields" :key="name">
            <div v-if="value.key === 'daystay'">
              <b-badge style="background-color: greenyellow">{{ item[value.key] }}</b-badge>
            </div>
            <div v-else>
              {{ item[value.key] }}
            </div>
          </b-td>
        </b-tr>
      </draggable>
    </b-table-simple>
  </b-card>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "PalletList",
  components: {
    draggable
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      drag: false,
      fields: [
        { key: "daystay", sortable: true, label: "Fifo" },
        { key: "creation_date", sortable: true, label: "Fecha" },
        { key: "pallet_number", sortable: true, label: "Numero" },
        { key: "lot_number", sortable: true, label: "Lote" },
        { key: "origin_name", sortable: true, label: "Huerto" },
        { key: "variety_name", sortable: true, label: "Variedad" },
        { key: "condition", sortable: true, label: "Condicion" },
        { key: "net_kilograms", sortable: true, label: "KG Net", class: "text-right" }
      ],
      localItems: []
    };
  },
  methods: {
    handleEnd() {
      this.drag = false;
      this.$emit("update", this.localItems);
    }
  },
  mounted() {
    this.localItems = this.items;
  }
};
</script>

<style>
.cursor-grabbing {
  cursor: grabbing;
}
.cursor-grab {
  cursor: grab;
}
</style>
